export default __webpack_public_path__ + "static/advocacy-desktop-fe79076e2dc89c7a6dc27b03c16c9200.png";